import { useFormContext } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

export default function AdviceSection() {
    const { register, formState } = useFormContext();

    return (
        <div className="space-y-2">
            <Textarea
                {...register("advice")}
                placeholder="Add advice..."
                rows={3}
                className={cn(
                    "text-xs bg-card border border-border rounded-md",
                    "focus:border-ring focus:outline-none focus-visible:ring-1 focus-visible:ring-ring/20",
                    "hover:border-border/60 placeholder:text-muted-foreground/40 placeholder:font-normal",
                    "resize-none min-h-[60px] px-3",
                    formState.errors?.advice && "border-destructive/60"
                )}
                maxLength={500}
            />
            {formState.errors?.advice && (
                <div className="text-xs text-destructive mt-1">
                    {formState.errors.advice.message as string}
                </div>
            )}
        </div>
    );
}